/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ToolMagicWandIcon20Light = forwardRef('ToolMagicWandIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M11.5 1a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 1 .5-.5Z" }),
        React.createElement("path", { d: "M11.5 12a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 1 .5-.5Z" }),
        React.createElement("path", { d: "M11.854 8.146a.5.5 0 0 1 0 .708l-9 9a.5.5 0 0 1-.708-.708l9-9a.5.5 0 0 1 .708 0Z" }),
        React.createElement("path", { d: "M16.803 3.904a.5.5 0 1 0-.707-.707l-2.121 2.121a.5.5 0 1 0 .707.707l2.121-2.121Z" }),
        React.createElement("path", { d: "M6.197 3.197a.5.5 0 0 1 .707 0l2.121 2.121a.5.5 0 0 1-.707.707L6.197 3.904a.5.5 0 0 1 0-.707Z" }),
        React.createElement("path", { d: "M13.975 10.975a.5.5 0 0 1 .707 0l2.121 2.121a.5.5 0 1 1-.707.707l-2.121-2.121a.5.5 0 0 1 0-.707Z" }),
        React.createElement("path", { d: "M18.5 9a.5.5 0 0 0 0-1h-3a.5.5 0 0 0 0 1h3Z" }),
        React.createElement("path", { d: "M7.5 9a.5.5 0 0 0 0-1h-3a.5.5 0 0 0 0 1h3Z" })));
});
